import { Injectable } from '@angular/core';
import { ImageMetaData } from '../shared/interfaces/meta-data.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImagesService {
  imagesMetaData: BehaviorSubject<ImageMetaData[]> = new BehaviorSubject<
    ImageMetaData[]
  >([]);

  setImagesMetaData(data: ImageMetaData[]) {
    this.imagesMetaData.next(data);
  }

  getImagesMetaData() {
    return this.imagesMetaData.asObservable();
  }

  getAltTextById(id: string): string | undefined {
    const imageMetaData = this.imagesMetaData
      .getValue()
      .find((image) => image.identifier === id);
    return imageMetaData?.metaFormData?.mediaAlternative;
  }
}
